<script setup>
import { computed } from 'vue';
import AiSuggestionList from '@/components/result/ai-literacy/AiSuggestionList.vue';

const props = defineProps({
    studentData: Object
});

const userRole = 'student';

// 보충학습 매핑 데이터
const suggestionData = {
  'e': {
    'a': {
      1: {
        feedback:
          '인공지능은 많은 데이터를 보고 규칙을 배우는 방식으로 작동해요. 예를 들어, 스팸 메일을 걸러내거나 추천 영상을 보여주는 것도 인공지능의 원리를 이용한 거예요. 다양한 사례를 살펴보면, 인공지능이 어떻게 작동하는지 더 쉽게 이해할 수 있어요.',
        study:
          "우리가 매일 접하는 일상 사례로 데이터의 개념을 정립하고 텍스트, 이미지 등 형태에 따른 분류 기준을 학습합니다. 직접 데이터를 분류하는 흥미로운 퀴즈를 통해 데이터의 속성을 직관적으로 이해하고, 디지털 세상을 구성하는 가장 기본적이고 핵심적인 단위인 데이터와 친해지는 실천 중심의 활동입니다.",
        url: 'http://s.senaidl.kr/QYgV5',
        qr: 'e-1-1.png'
      },
      2: {
        feedback:
          '기계학습은 인공지능이 데이터를 보고 배우는 과정이에요. 사람처럼 직접 가르쳐주는 것이 아니라, 많은 데이터를 보고 스스로 패턴을 찾는 것이 특징이에요. 기계학습을 이해하면, 인공지능이 어떻게 학습하는지 쉽게 알 수 있어요.',
        study:
          "인공지능이 데이터를 수집하고 전처리, 라벨링하여 예측에 이르는 학습의 전 과정을 AI 스피커 사례로 생생하게 살펴봅니다. 수많은 정보 속에서 AI가 스스로 규칙을 찾아내고 판단하는 원리를 이해하며, 인공지능에게도 인간처럼 체계적인 배움의 단계가 필요함을 깨닫습니다.",
        url: 'http://s.senaidl.kr/kvdgN',
        qr: 'e-3-4.png'
      },
      3: {
        feedback:
          '인공지능이 만들어지려면 많은 데이터가 필요해요. 데이터를 모으고, 정리하고, 학습시키는 과정이 중요해요. 인공지능이 잘 학습하기 위해서는 좋은 데이터를 모으고 잘 분류하여 학습시켜야 합니다. 인공지능의 학습 과정을 알면, 인공지능이 어떻게 발전하는지 더 잘 이해할 수 있어요.',
        study:
          "인공지능이 데이터를 수집하고 전처리, 라벨링하여 예측에 이르는 학습의 전 과정을 AI 스피커 사례로 생생하게 살펴봅니다. 수많은 정보 속에서 AI가 스스로 규칙을 찾아내고 판단하는 원리를 이해하며, 인공지능에게도 인간처럼 체계적인 배움의 단계가 필요함을 깨닫습니다.",
        url: 'http://s.senaidl.kr/kvdgN',
        qr: 'e-3-3.png'
      },
      5: {
        feedback:
          '인공지능은 데이터를 기반으로 학습하고 결정을 내려요. 예를 들어, 날씨 데이터를 모아 비 오는 날과 맑은 날의 패턴을 찾거나, 좋아하는 음식의 영양 정보를 비교해 건강한 식단을 만들 수도 있어요. 우리도 일상에서 데이터를 모으고 분석하는 연습을 하면, 인공지능이 어떻게 작동하는지 더 잘 이해할 수 있어요.',
        study:
          '일상 속 친숙한 사례로 데이터의 개념을 정립하고, 텍스트와 이미지 등 형태별 분류 기준을 체계적으로 학습합니다. 특히 직접 데이터를 분류해 보는 실습형 퀴즈를 통해 데이터의 핵심 속성을 직관적으로 파악할 수 있도록 구성된 활동입니다. 이를 통해 데이터 문해력을 기를 수 있습니다.',
        url: 'http://s.senaidl.kr/QYgV5',
        qr: 'e-4-2.png'
      },
      7: {
        feedback:
          '지능형 로봇은 사람을 도와주는 다양한 역할을 해요. 예를 들어, 청소 로봇, 병원에서 약을 배달하는 로봇, 공장에서 물건을 조립하는 로봇이 있어요. 지능형 로봇은 다른 로봇과 달리 주변환경을 인식하고 자율적으로 판단하여 행동합니다. 이런 로봇들을 찾아보면, 인공지능이 어떻게 활용되는지 알 수 있어요.',
        study:
          "유튜브 추천 알고리즘과 번역기 등 우리 일상과 산업 전반에 스며든 AI의 활약을 살펴봅니다. 주변의 일상 속에서 인공지능 사례를 직접 찾아보며, 기술과 공존할 미래를 탐색하고 인공지능을 막연한 기술이 아닌 유용한 파트너로 인식하며, AI의 놀라운 능력을 확인하는 학습 활동입니다.",
        url: 'http://s.senaidl.kr/F1Fbo',
        qr: 'e-1-4.png'
      },
      11: {
        feedback:
          '생성형 인공지능으로 그림을 만들 때는 한 번에 완벽한 결과가 나오지 않을 수 있어요. 또 같은 프롬프트를 입력하더라도 매번 조금씩 다른 그림이 만들어질 수 있어요. 그래서 생성형 인공지능을 활용할 때에는 원하는 요소를 더 구체적으로 담아 프롬프트를 작성하면 내가 원하는 모습에 더 가깝게 만들 수 있어요.',
        study:
          "프롬프트 구성에 따른 AI 답변의 변화를 직접 비교하며 체험합니다. 구체적인 정보와 맥락이 답변의 정교함을 어떻게 높이는지 살피고, 효과적인 소통법인 ‘프롬프트 엔지니어링’의 기초를 익힙니다. AI를 똑똑하게 활용하는 ‘질문의 기술’을 통해 디지털 문제 해결 능력을 실무적으로 키우는 활동입니다.",
        url: 'http://s.senaidl.kr/biuLL',
        qr: 'e-5-4.png'
      },
      14: {
        feedback:
          '우리 주변에는 인공지능이 많이 쓰이고 있어요. 스마트폰 음성비서, 추천 영상, 내비게이션, 자율주행 자동차처럼 다양한 서비스가 더 편리해졌죠. 스팸메일 차단이나 사진 보정, 번역 기능도 인공지능 덕분이에요. 생활 속 사례를 찾아보면, 우리가 언제 어떻게 인공지능을 활용하는지 더 분명하게 이해할 수 있어요.',
        study:
          "전통적 프로그래밍과 기계학습의 근본적인 차이를 비교하며, 인공지능이 스스로 규칙을 찾아내는 원리를 탐구합니다. (비)지도학습, 강화학습의 개념을 사례로 익히고, 데이터로부터 지식을 창조하는 AI의 학습 방식을 이해함으로써 인공지능 시대의 핵심 기초 소양을 기를 수 있도록 구성된 활동입니다.",
        url: 'http://s.senaidl.kr/dUsep',
        qr: 'e-2-1.png'
      },
      15: {
        feedback:
          '인공지능은 편리한 기술이지만 늘 좋은 것만은 아니에요. 빠르게 정보를 찾고 글·그림을 만들 수 있지만 가짜 뉴스나 편향된 내용이 함께 퍼질 수도 있어요. 특히 인공지능 결과물은 그럴듯해 보여도 거짓이나 오류를 포함할 수 있으니 바로 믿지 말고 출처를 확인하고 여러 자료와 비교해 꼭 점검해야 해요.',
        study:
          "인공지능의 답변에 오류가 섞일 수 있음을 인지하고, 퀴즈와 사례를 통해 정보를 무조건 신뢰하기보다 꼼꼼히 따져보는 비판적 검토 태도를 기릅니다. 정보 활용의 최종 책임이 사용자에게 있음을 학습하며, 올바른 정보를 선별해내는 책임감 있는 디지털 시민으로 성장하는 실천적 활동입니다.",
        url: 'http://s.senaidl.kr/cN4WH',
        qr: 'e-5-3.png'
      },

      18: {
        feedback:
          '인공지능은 빠르게 계산하고 많은 데이터를 분석하는 일을 잘해요. 예를 들어 번역을 하거나 사진을 보고 물건을 알아맞히고 스팸메일을 구분하거나 길을 추천하는 것도 잘해요. 사람에게는 시간이 오래 걸리는 반복 작업을 대신해 주기도 해요. 이런 특징을 알면 필요할 때 적절한 곳에 인공지능을 활용할 수 있어요.',
        study:
          'AI과 일반 기계의 차이점을 명확히 비교하고, 퀴즈를 통해 인공지능 여부를 직접 구분해 봅니다. 스스로 판단하는 AI의 핵심 원리를 이해한 뒤, 반짝이는 아이디어를 더해 일상 속 사물을 똑똑한 AI 기기로 변신시켜 보는 창의적 탐구 활동입니다. 직관적인 개념 습득과 상상력을 바탕으로 AI과 소통하는 미래 역량을 기릅니다.',
        url: 'http://s.senaidl.kr/TU2rI',
        qr: 'e-4-1.png'
      },
      20: {
        feedback:
          '생성형 인공지능은 그림을 그리거나 이야기를 만들어낼 수 있어요. 우리가 입력한 문장(프롬프트)에 따라 새로운 것을 만들어주는 것이 특징이에요. 생성형 인공지능이 할 수 있는 일을 알면, 다양한 방법으로 활용할 수 있을 거예요.',
        study:
          "사람은 마음과 의도를 담아 창작하지만, AI는 수많은 데이터를 조합해 그럴듯한 패턴을 찾아냅니다. AI가 문장의 의미를 직접 이해하는 대신, 데이터 속 통계적 확률에 따라 다음에 올 단어나 이미지를 생성하는 '확률적 생성'의 원리를 살펴봅니다. 인공지능이 결과물을 만들어내는 과학적 과정을 이해하며 기술의 본질을 탐구하는 활동입니다.",
        url: 'http://s.senaidl.kr/S7fTz',
        qr: 'e-5-1.png'
      },
      22: {
        feedback:
          '인공지능이 만들어지려면 많은 데이터가 필요해요. 데이터를 모으고, 정리하고, 학습시키는 과정이 중요해요. 인공지능 학습 모델을 만들고 나면 인공지능 모델이 제대로 학습했는지 확인해야 해요. 그리고 나서 인공지능 모델을 사용할지 더 학습시킬지 결정해요.',
        study:
          '일상 속 친숙한 사례를 통해 데이터의 개념을 명확히 정립합니다. 텍스트, 이미지 등 형태에 따른 분류 기준을 익히고, 직접 데이터를 분류해 보는 퀴즈를 통해 데이터의 속성을 직관적으로 이해할 수 있도록 구성했습니다. 정보를 체계적으로 관리하고 활용하는 데이터 문해력의 기초를 다지는 체험 중심의 학습 활동입니다.',
        url: 'http://s.senaidl.kr/QYgV5',
        qr: 'e-4-3.png'
      },
      23: {
        feedback:
          '우리 주변의 많은 자동화 기술에는 인공지능 기술을 활용하기도 해요. 그러나 모든 자동화 기술이 인공지능은 아니에요. 인공지능(AI)은 단순히 정해진 규칙대로 작동하는 것을 넘어 데이터를 보고 상황을 이해한 뒤(인식), 분석하고 판단해서(분석·판단), 그 결과에 따라 행동을 바꾸는(조절) 특징이 있어요.',
        study:
          '유튜브 추천 알고리즘과 번역기 등 우리 곁에 스며든 AI의 활약을 살펴봅니다. 일상 속 인공지능 사례를 직접 찾아보며 기술의 놀라운 능력을 확인하고, AI와 공존할 미래를 탐색합니다. 인공지능을 막연한 기술이 아닌 유용한 파트너로 인식하며, 변화하는 미래 사회를 주도적으로 준비하는 디지털 소양을 기르는 활동입니다.',
        url: 'http://s.senaidl.kr/F1Fbo',
        qr: 'e-3-1.png'
      },
      27: {
        feedback:
          '인공지능은 데이터를 기반으로 학습하고 결정을 내려요. 예를 들어, 날씨 데이터를 모아 비 오는 날과 맑은 날의 패턴을 찾거나, 좋아하는 음식의 영양 정보를 비교해 건강한 식단을 만들 수도 있어요. 인공지능처럼 데이터 분석하는 연습을 하면 인공지능이 데이터를 분석하는 방식과 그 중요성을 더 쉽게 알 수 있을 거예요.',
        study:
          '인공지능이 데이터를 수집하고 전처리, 라벨링하여 예측에 이르는 학습의 전 과정을 AI 스피커 사례로 생생하게 살펴봅니다. 수많은 정보 속에서 AI가 스스로 규칙을 찾아내고 판단하는 원리를 이해하며, 인공지능에게도 인간처럼 체계적인 배움의 단계가 필요함을 깨닫습니다.',
        url: 'http://s.senaidl.kr/kvdgN',
        qr: 'e-3-2.png'
      },
      29: {
        feedback:
          '인공지능의 개념과 원리를 잘 이해하고 있으며, 다양한 사례를 통해 인공지능이 어떻게 활용되는지 폭넓게 학습하였습니다. 앞으로도 인공지능의 발전과 활용 방안에 관심을 가지고 지속적으로 탐구해 보시기 바랍니다.',
        study:
          '유튜브 추천 알고리즘과 번역기 등 우리 곁에 스며든 AI의 활약을 살펴봅니다. 일상 속 인공지능 사례를 직접 찾아보며 기술의 놀라운 능력을 확인하고, AI와 공존할 미래를 탐색합니다. 인공지능을 단순한 도구가 아닌 파트너로 인식하며, 변화하는 사회를 주도적으로 준비하는 디지털 소양을 기르는 학습 활동입니다.',
        url: 'http://s.senaidl.kr/F1Fbo',
        qr: 'e-a-2.png'
      }
    },
    'b': {
      4: {
        feedback:
          '우리는 학습을 위해 인공지능에게 문제를 만들게 하거나, 다양한 자료를 정리하도록 도움을 받을 수 있어요. 하지만 인공지능도 때때로 사실과 다른 내용을 말하거나 표현이 애매할 수 있어요. 그래서 교과서나 책의 내용과 비교해 확인하고, 틀린 부분은 수정하거나 빼면서 활용하는 태도가 가장 중요해요.',
        study:
          "'디지털 마법학교 입학 시험'이라는 흥미로운 설정으로 방탈출 형태의 3가지 미션을 해결합니다. 학생들이 AI·디지털 도구를 학습에 직접 활용하며 마법 같은 기술을 체험하고, 도구별 장단점 평가표를 작성하며 각 도구의 특성과 한계를 스스로 체득하는 활동입니다.",
        url: 'http://s.senaidl.kr/TN0YX ',
        qr: 'e-2-5.png'
      },
      6: {
        feedback:
          '우리는 인공지능을 활용해 일상과 학습에서 마주하는 다양한 문제를 더 쉽고 빠르게 해결할 수 있어요. 인공지능을 효과적으로 사용하려면 내가 해결하고 싶은 문제의 목적을 분명히 하고 그 목적에 알맞은 인공지능 도구를 선택해 활용해야 해요. 인공지능에게 필요한 정보를 제공하며 결과를 함께 점검해 주어야 해요.',
        study:
          "일상의 문제를 해결하기 위해 디지털 플랫폼과 기기를 직접 활용하며 그 해결 과정을 검증하는 방법을 학습합니다. 우리 주변에서 겪는 고민들을 디지털 기술로 해소할 수 있음을 경험적으로 체득하도록 구성했습니다. 스스로 점검하며 디지털 기술을 문제 해결의 강력한 열쇠로 활용하는 능력을 기르는 실천적 활동입니다.",
        url: 'http://s.senaidl.kr/3y7Nr',
        qr: 'e-1-2.png'
      },
      12: {
        feedback:
          '인공지능은 많은 데이터를 보고 규칙을 배우는 방식으로 작동해요. 예를 들어, 스팸 메일을 걸러내거나 추천 영상을 보여주는 것도 인공지능의 원리를 이용한 거예요. 다양한 사례를 살펴보면, 인공지능이 어떻게 작동하는지 더 쉽게 이해할 수 있어요.',
        study:
          "일상 속 버스 도착 예측, 무인 계산, 스마트 스피커, 자동 번역 등 친숙한 사례를 통해 AI가 우리 삶의 편리함과 효율성을 어떻게 높이는지 살펴봅니다. 다양한 인공지능 활용 현장을 탐색하며 기술의 원리를 이해하고, 인공지능과 함께 살아갈 미래 사회에서 AI의 역할과 공존의 가치를 고민해 볼 수 있는 카드뉴스 기반의 학습 자료입니다.",
        url: 'http://s.senaidl.kr/6lVfj ',
        qr: 'e-2-3-1.png'
      },
      13: {
        feedback:
          '우리는 인공지능을 이용해 다양한 문제를 해결할 수 있어요. 예를 들어 길 찾기 앱은 가장 빠른 길을 추천해 주고 음성 번역기는 다른 나라 말도 쉽게 이해하도록 도와줘요. 인공지능은 먼저 많은 데이터를 학습한 후, 사용자가 원하는 상황과 조건을 바탕으로 가장 알맞은 해결 방법을 예측해 제시해 줍니다.',
        study:
          "버스 도착 예측 등 친숙한 사례로 AI가 삶의 편리함과 효율성을 높이는 과정을 살펴봅니다. 생활 속 인공지능 활용 현장을 탐색하며 기술의 가치를 체감하고, AI와 공존할 미래 사회의 역할과 우리의 자세를 깊이 있게 고민합니다. 카드뉴스 기반의 시각 자료를 통해 인공지능에 대한 올바른 인식을 기르는 실천적 학습 활동입니다.",
        url: 'http://s.senaidl.kr/6lVfj ',
        qr: 'e-2-2.png'
      },
      24: {
        feedback:
          '인공지능은 많은 데이터를 보고 규칙을 배우는 방식으로 작동해요. 예를 들어, 스팸 메일을 걸러내거나 추천 영상을 보여주는 것도 인공지능의 원리를 이용한 거예요. 다양한 사례를 살펴보면, 인공지능이 어떻게 작동하는지 더 쉽게 이해할 수 있어요.',
        study:
          "버스 도착 예측 등 친숙한 사례를 통해 AI가 삶의 편리함과 효율성을 어떻게 높이는지 살펴봅니다. 생활 속 인공지능 활용 현장을 탐색하며 기술의 가치를 체감하고, AI와 공존할 미래 사회에서 인공지능의 역할과 우리의 자세를 깊이 있게 고민해 볼 수 있는 카드뉴스 기반 학습 자료입니다.",
        url: 'http://s.senaidl.kr/6lVfj ',
        qr: 'e-2-3-2.png'
      },
      26: {
        feedback:
          '의료, 농업, 교통 등 다양한 분야에서 인공지능이 활용되고 있어요. 예를 들어, 농장에서 인공지능이 작물이 잘 자라는 환경을 분석하거나, 공장에서 불량품을 찾아내는 데 사용될 수도 있어요.',
        study:
          "생성형 AI로 만든 글 등 실제 창작 사례를 직접 살펴보며 기술의 가능성을 탐구합니다. 콘텐츠 제작 과정에서 AI가 주는 편리함과 창의적 영감이라는 장점, 그리고 저작권이나 왜곡 문제 같은 한계를 날카롭게 비교·분석합니다. 생성형 AI의 특성을 정확히 이해하고, 목적에 맞게 도구를 활용하는 비판적 제작 능력을 기르는 활동입니다.",
        url: 'http://s.senaidl.kr/OFVXh ',
        qr: 'e-5-6.png'
      },
      28: {
        feedback:
          '인공지능이 생활 속에서 어떻게 사용되는지 깊이 이해하고 있으며, 이를 문제 해결에 적용하는 능력이 뛰어납니다. 앞으로는 다양한 인공지능 도구를 직접 활용해 보고, 이를 실생활과 학습에 적극적으로 적용해 보시길 바랍니다.',
        study:
          "만화 형식의 3가지 에피소드(독후감, 식물·동네 조사)로 학습 중 AI와 디지털 도구를 쓸 때 마주할 수 있는 문제점을 생생하게 살펴봅니다. 사례를 통해 잘못된 정보나 의존의 위험성을 인지하고, '다짐 체크리스트'를 작성하며 정보를 비판적으로 검증하는 태도를 기릅니다. 기술을 올바르게 활용하는 주체적인 학습 습관을 형성하도록 돕는 교육 자료입니다.",
        url: 'http://s.senaidl.kr/Gjx66',
        qr: 'e-a-1.png'
      }
    },
    'c': {
      9: {
        feedback:
          '인공지능은 많은 데이터를 활용하므로 개인정보를 안전하게 지키는 것이 무엇보다 중요해요. 우리가 인터넷에 올리는 개인정보도 인공지능에 의해 분석될 수 있어요. 만약 개인정보를 공유하면 인공지능이 이를 활용해 광고를 추천하거나 사생활이 노출될 수도 있어요. 따라서 SNS에 올리는 정보를 신중하게 선택해야 해요.',
        study:
          '개인정보 보호 카드뉴스 "내 정보 내가 지킨다."는 초등학생이 온라인에서 개인정보의 의미와 노출 위험을 실생활 사례로 쉽게 이해하도록 돕습니다. 학생 스스로 정보를 보호하는 책임감을 기르고, 안전한 디지털 습관을 형성하게 하는 시민교육 자료입니다.',
        url: 'http://s.senaidl.kr/qAmUo ',
        qr: 'e-1-3.png'
      },
      10: {
        feedback:
          '생성형 인공지능은 우리가 원하는 문구를 빠르게 만들어 줄 수 있어요. 하지만 인공지능이 만든 문구가 항상 사실과 맞는 것은 아니고 때로는 과장되거나 틀린 내용이 들어갈 수도 있어요. 그래서 인공지능을 사용할 때는 사실을 확인하고 정확한 표현으로 고쳐서 사용하는 태도가 가장 중요해요.',
        study:
          '학생이 실생활에서 빈번하게 겪을 수 있는 디지털 권리 침해 상황을 바탕으로, 학생들이 해야하는 올바른 행동을 선택형 문제로 풀어보며, 해결 능력을 키웁니다. 이를 통해 AI 주체성, 비판력, 윤리성, 안전성 등 AI 디지털 윤리에 대해 배울 수 있는 교육자료 입니다. 기술을 올바르게 통제하고 책임감 있게 사용해야 합니다.',
        url: 'http://s.senaidl.kr/XO9iS ',
        qr: 'e-5-5.png'
      },
      16: {
        feedback:
          '인공지능을 사용할 때는 주의할 점이 있어요. 인공지능도 때때로 잘못 판단할 수 있으니 결과를 무조건 믿기보다 참고용으로 활용하는 것이 좋아요. 또 개인정보는 함부로 입력하지 말고 중요한 내용은 출처를 확인해 한 번 더 점검해야 해요. 이렇게 안전한 사용 방법을 익히면 더 똑똑하게 활용할 수 있어요.',
        study:
          '초등학생이 실생활 사례를 통해 온라인 개인정보의 의미와 노출 위험을 쉽게 이해하도록 돕는 카드뉴스입니다. 스스로 정보를 보호하는 책임감을 기르고 안전한 디지털 습관을 형성하며, 올바른 보안 수칙을 익혀 소중한 정보를 지키는 건강한 디지털 시민으로 성장하게 합니다.',
        url: 'http://s.senaidl.kr/qAmUo',
        qr: 'e-2-4.png'
      },
      17: {
        feedback:
          '인공지능은 편리한 기술이지만, 반드시 좋은 면만 있지는 않아요. 예를 들어, 인공지능 덕분에 빠르게 정보를 찾을 수 있지만, 가짜 뉴스가 퍼질 수도 있어요. 장점과 단점을 함께 생각해보는 것이 중요해요.',
        study:
          "'인공지능의 착한 얼굴? 나쁜 얼굴?'은 AI가 사회에 미치는 양면적 영향을 탐색하는 활동입니다. 일상 속 사례를 시작으로 영상 시청과 키워드 검색을 통해 AI의 긍정적 기여와 부정적 위험성을 스스로 조사해 봅니다. 기술의 빛과 그림자를 균형 있게 바라보며 비판적 사고력을 키우는 교육 자료입니다.",
        url: 'http://s.senaidl.kr/vedHU',
        qr: 'e-3-6.png'
      },
      21: {
        feedback:
          '인공지능을 사용할 때는 주의해야 할 점이 있어요. 예를 들어, 가짜 영상(딥페이크)이나 저작권 문제를 조심해야 해요. 안전하게 인공지능을 사용하는 방법을 배우면, 더 똑똑하게 활용할 수 있어요.',
        study:
          '‘내 정보 내가 지킨다’ 카드뉴스는 초등학생이 온라인 속 개인정보의 의미와 노출 위험을 실생활 사례로 쉽게 이해하도록 돕습니다. 스스로 정보를 보호하는 책임감을 기르고, 안전한 디지털 습관을 형성하게 하는 시민교육 자료입니다. 올바른 보안 수칙을 익혀 소중한 개인정보를 스스로 지키는 건강한 디지털 시민으로 성장하게 합니다.',
        url: 'http://s.senaidl.kr/qAmUo',
        qr: 'e-4-5.png'
      },
      30: {
        feedback:
          '인공지능을 사용할 때 윤리적인 관점을 고려하며, 개인정보 보호와 공정한 AI 활용의 중요성을 잘 이해하고 있습니다. 앞으로도 인공지능을 안전하고 책임감 있게 사용하며, 이를 통해 더욱 발전된 사고력을 기를 수 있도록 노력해 보시기 바랍니다.',
        study:
          "'AI 탐정단: 두 얼굴의 도시를 구해라!'는 일상 속 상황을 통해 인공지능의 이로운 점과 해로운 점을 균형 있게 탐색하는 활동입니다. 도시 곳곳의 사건을 해결하며 기술의 양면성을 스스로 파악하고, AI를 올바르게 바라보는 비판적 태도를 기릅니다. 인공지능과 공존할 미래를 위해 꼭 필요한 디지털 윤리 의식을 탐정 놀이처럼 흥미롭게 배울 수 있는 자료입니다.",
        url: 'http://s.senaidl.kr/C8NRK',
        qr: 'e-a-3.png'
      }
    },
    'd': {
      8: {
        feedback:
          '사람과 인공지능이 함께 일하면 더 좋은 결과를 낼 수 있어요. 예를 들어, 의사가 병을 진단할 때 인공지능이 도움을 주거나, 음악을 만들 때 인공지능이 아이디어를 줄 수도 있어요. 인공지능과 함께 일해야 할 때에는 사람이 해야 하는 부분과 인공지능이 해야 하는 부분을 생각해보아야 해요.',
        study:
          '친숙한 만화 설정을 통해 AI와의 올바른 협업 태도를 탐구합니다. AI의 답변을 맹목적으로 수용하기보다 비판적으로 사고하고 스스로 결정하는 \'주체적인 나\'의 역할을 이해합니다. 활동을 통해 AI의 한계를 인식하고 책임감 있는 활용 약속을 정하며, 기술과 지혜롭게 공존하는 미래 핵심 역량을 기릅니다.',
        url: 'http://s.senaidl.kr/lvXKW ',
        qr: 'e-3-5.png'
      },
      19: {
        feedback:
          '우리는 인공지능을 활용하면 일을 빠르고 편리하게 할 수 있어요. 하지만 인공지능의 판단이 항상 완벽한 것은 아니기 때문에 인공지능의 결과를 기준으로 조건을 걸어 필요한 행동만 하도록 프로그램을 만드는 것이 중요해요.',
        study:
          '일상 속 실례를 통해 AI의 개념을 발견하고, 실제 장면 속 AI 요소를 찾아보며 디지털 문해력을 높입니다. 직접 경험한 사례를 공유하며 AI와의 협업 윤리를 퀴즈로 재미있게 익힙니다. AI와 함께하는 하루를 성찰하며 기술과 조화롭게 공존하는 태도를 기르고 실천 역량을 함양합니다.',
        url: 'http://s.senaidl.kr/E09Aw',
        qr: 'e-4-4.png'
      },
      25: {
        feedback:
          '지속가능한 발전을 위해 AI를 활용하면 많은 데이터를 빠르게 분석해서 문제를 더 정확하게 이해하고 해결 방법을 찾는 데 도움을 줄 수 있어요. 예를 들어 무인카메라를 이용해 멸종위기생물의 서식지를 파악하고 보호하거나 큰 산불 뒤에 AI가 사진 데이터를 분석해 피해가 심한 구역을 빠르게 추정해서 도울 수 있어요.',
        study:
          '일상 속 친숙한 사례를 통해 인공지능의 개념과 활용 모습을 탐구합니다. AI가 사라진 세상을 상상하며 그 필요성과 영향을 성찰하고, 기술이 인간을 향해야 한다는 \'인간중심 AI\'의 가치를 배웁니다. 나아가 사람에게 도움을 주는 창의적인 AI 아이디어를 설계하며 미래 공존 역량을 키웁니다.',
        url: 'http://s.senaidl.kr/tG3tS',
        qr: 'e-5-2.png'
      },
      31: {
        feedback:
          '인공지능은 우리 일을 도와주는 유용한 도구로, 잘 활용하면 삶이 훨씬 편리해집니다. 하지만 사용하기 전에 우리가 직접 해야 할 일과 인공지능에게 맡겨도 될 일을 잘 구분해야 합니다. 인공지능과 어떤 사이가 되는 것이 좋을지 한번 곰곰이 생각해보세요.',
        study:
          '일상 속 친숙한 사례를 통해 인공지능의 개념과 활용 모습을 탐구합니다. AI가 사라진 세상을 상상하며 그 필요성과 영향을 성찰하고, 기술이 인간을 향해야 한다는 \'인간중심 AI\'의 가치를 배웁니다. 나아가 사람에게 도움을 주는 창의적인 AI 아이디어를 설계하며 미래 공존 역량을 키웁니다.',
        url: 'http://s.senaidl.kr/tG3tS',
        qr: 'e-a-4.png'
      }
    }
  },

  'm': {
    'a': {
      1: {
        feedback:
          '인공지능은 데이터를 분석하고 학습해 결과를 만들어 내요. 사물을 인식하는 컴퓨터 비전이나 우리말을 이해하는 음성 인식은 인공지능이 사용된 사례예요. 반면 계산기처럼 직접 조작하는 기계는 인공지능이 아니에요. 이런 차이를 알면 우리 주변의 인공지능이 어떤 원리로 작동하는지 이해할 수 있어요.',
        study:
          "음성 비서와 번역기 등 일상 속 사례를 통해 AI의 핵심 원리를 쉽고 명확하게 이해합니다. 배운 내용을 바탕으로 직접 ‘AI 관찰 기록’을 작성하며 우리 곁에 숨어 있는 AI의 활약을 스스로 발견해 봅니다. 기술을 실생활의 유용한 도구로 경험하며 디지털 기초 소양을 탄탄하게 다지는 밀착형 활동입니다.",
        url: 'http://s.senaidl.kr/jVreg',
        qr: 'm-3-1.png'
      },
      2: {
        feedback:
          '인공지능은 주어진 데이터를 분석하고, 학습을 통해 패턴을 찾아 결과를 도출해요. 예를 들어, 온라인 쇼핑몰의 추천 시스템은 사용자의 구매 이력을 분석하여 관심 있을 만한 상품을 추천해요. 이러한 과정을 이해하면, 기계학습을 통해 인공지능이 어떻게 추천과 예측을 하는지 더 잘 이해할 수 있어요.',
        study:
          "인공지능이 데이터 속 패턴을 찾아 문제를 해결하는 과학적 과정을 탐구하며 공익을 위해 데이터를 나누는 ‘데이터 필란트로피’ 사례를 통해 기술이 만드는 사회적 가치를 살펴봅니다. 데이터의 힘으로 더 나은 세상을 만드는 ‘데이터 히어로’로서 책임감을 느끼고, 올바른 활용을 실천하는 태도를 기르는 활동입니다.",
        url: 'http://s.senaidl.kr/wb4BV',
        qr: 'm-4-3.png'
      },
      3: {
        feedback:
          '기계학습 모델은 데이터 수집 → 데이터 학습 → 예측과 판단의 과정을 거쳐 만들어져요. 먼저 충분한 데이터를 모으고, 이를 바탕으로 특정 패턴을 학습한 후, 새로운 데이터를 입력하면 결과를 예측해요. 이 과정을 이해하면 기계학습을 활용한 다양한 프로젝트를 설계하고 구현할 수 있어요.',
        study:
          "일상 속 친숙한 사례를 통해 막연했던 데이터의 개념을 명확히 정립합니다. 텍스트, 이미지 등 형태에 따른 분류 기준을 익히고, 직접 데이터를 분류해 보는 체험형 퀴즈를 통해 데이터의 속성을 직관적으로 이해할 수 있도록 구성했습니다. 정보를 체계적으로 관리하고 활용하는 데이터 문해력의 기초를 다지는 학습 활동입니다.",
        url: 'http://s.senaidl.kr/QYgV5',
        qr: 'm-1-1.png'
      },
      7: {
        feedback:
          '생성형 인공지능은 주어진 정보를 바탕으로 새로운 콘텐츠를 만들어내는 인공지능이에요. 예를 들어, 글 생성 인공지능은 입력된 질문을 기반으로 새로운 글을 생성하고, 그림 생성 인공지능은 사용자의 설명을 바탕으로 이미지를 그릴 수 있어요. 이런 기술을 이해하면 창의적인 작업에도 인공지능을 활용할 수 있어요.',
        study:
          "일상 속 친숙한 사례를 통해 막연했던 데이터의 개념을 명확히 정립합니다. 텍스트, 이미지 등 형태에 따른 분류 기준을 익히고, 직접 데이터를 분류해 보는 체험형 퀴즈를 통해 데이터의 속성을 직관적으로 이해할 수 있도록 구성했습니다. 정보를 체계적으로 관리하고 활용하는 데이터 문해력의 기초를 다지는 학습 활동입니다.",
        url: 'http://s.senaidl.kr/QYgV5',
        qr: 'm-2-2.png'
      },
      8: {
        feedback:
          '인공지능은 주어진 데이터를 분석하고 학습을 통해 패턴을 찾아 결과를 만들어 내요. 예를 들어 인공지능 비서는 사용자의 질문 의도를 파악하여 필요한 정보를 찾아 답을 해요. 사진 속 물건을 알아맞히거나 번역을 하는 것도 같은 원리예요. 이런 원리를 이해하면 인공지능의 작동원리를 더 쉽게 파악할 수 있어요.',
        study:
          "음성 비서와 번역기 등 친숙한 사례로 AI의 핵심 원리를 이미지와 짧은 문장을 통해 쉽고 명확하게 이해합니다. 직접 ‘AI 관찰 기록’을 작성하며 우리 곁에 숨어 있는 인공지능의 활약을 스스로 발견하고 탐구해 봅니다. 기술을 실생활의 유용한 도구로 경험하며 디지털 기초 소양을 탄탄하게 다지는 밀착형 활동입니다.",
        url: 'http://s.senaidl.kr/jVreg',
        qr: 'm-3-3.png'
      },
      16: {
        feedback:
          '생성형 인공지능은 방대한 데이터를 학습하여 새로운 콘텐츠를 만들어내는 방식으로 작동해요. 예를 들어, 그림 생성 AI는 기존 그림을 학습한 후, 새로운 그림을 그릴 수 있는 패턴을 찾아내요. 이런 원리를 이해하면, 생성형 인공지능을 더욱 효과적으로 활용할 수 있어요.',
        study:
          "토큰 예측과 노이즈 제거 등 생성형 AI의 핵심 원리를 탐구합니다. AI의 결과가 정답이 아닌 확률에 기반한다는 점을 이해하고, 정보를 비판적으로 읽는 눈을 기릅니다. 답변을 무조건 믿기보다 스스로 검증하고 판단하며, 기술을 지혜롭게 다루는 주체적인 사용자로 성장하는 활동입니다.",
        url: 'http://s.senaidl.kr/qAenk',
        qr: 'm-5-4.png'
      },
      17: {
        feedback:
          '인공지능은 주어진 데이터를 분석하고, 학습을 통해 패턴을 찾아 결과를 도출해요. 예를 들어, 온라인 쇼핑몰의 추천 시스템은 사용자의 구매 이력을 분석하여 관심 있을 만한 상품을 추천해요. 이런 원리를 이해하면, 인공지능이 어떻게 작동하는지 더 쉽게 파악할 수 있어요.',
        study:
          "방대한 정보 중 나에게 꼭 필요한 것만 골라주는 추천 알고리즘의 개념과 우리 주변에서 흔히 쓰이는 다양한 방식들을 살펴봅니다. 특히 가장 대표적인 방식인 협업 필터링의 원리를 집중적으로 탐구합니다. 실제 예제를 통해 알고리즘이 작동하는 과정을 직관적으로 이해하고 확인해 보는 학습 활동입니다.",
        url: 'http://s.senaidl.kr/C0m4D',
        qr: 'm-4-1.png'
      },
      18: {
        feedback:
          '인공지능이 정확한 판단을 하기 위해서는 올바른 데이터 수집과 분석이 중요해요. 먼저 데이터를 모으고(수집), 필요 없는 데이터를 정리한 후(전처리), 이를 분석하여 패턴을 찾고(분석), 최종적으로 인공지능이 활용할 수 있도록 가공해야 해요. 이러한 과정이 잘 진행될수록 인공지능이 더 정확한 결과를 낼 수 있어요.',
        study:
          '방대한 정보 속에서 나에게 딱 맞는 콘텐츠를 골라주는 추천 알고리즘의 개념과 실생활 속 다양한 사례를 살펴봅니다. 특히 사용자의 행동 데이터를 분석해 취향을 예측하는 대표적 방식인 협업 필터링의 원리를 집중적으로 탐구합니다.',
        url: 'http://s.senaidl.kr/C0m4D',
        qr: 'm-4-2.png'
      },
      21: {
        feedback:
          '생성형 인공지능을 사용하려면 프롬프트를 잘 작성해야 해요. 예를 들어, 그림 생성 인공지능에 "새"라고 입력하는 것보다는 "초록색 숲에서 노래하는 새"라고 입력하면 이에 맞는 이미지를 생성할 수 있어요. 만약 생성한 이미지가 원하는 결과물과 다르다면 프롬프트를 수정하거나 피드백을 입력해야 해요.',
        study:
          "프롬프트 구성에 따라 AI의 답변이 어떻게 달라지는지 직접 체험합니다. 막연한 질문에 구체적인 정보를 더할 때 답변이 정교해지는 과정을 확인하며 효과적인 소통 기술을 익힙니다. AI을 똑똑한 파트너로 활용하기 위해 꼭 필요한 올바른 질문법의 기초를 다지고, 원하는 결과를 이끌어내는 능력을 키우는 활동입니다.",
        url: 'http://s.senaidl.kr/biuLL',
        qr: 'm-5-3.png'
      },
      26: {
        feedback:
          '인공지능은 수집된 데이터를 분석하고 학습한 결과를 바탕으로 추천이나 안내를 제공하는 기술이에요. 우리 주변에서 사용하는 인공지능 서비스를 살펴보며, 인공지능의 특징과 주요 원리를 탐구해 보기를 바랍니다.',
        study:
          "카드 게임으로 AI의 정의를 풀고, 인간의 사고를 모방한 기계학습과 딥러닝을 이해합니다. \"이건 AI일까?\" 퀴즈와 인터랙션으로 일상 속 인공지능을 감별하며, 똑똑한 기계의 원리를 재미있게 체득하는 기초 소양 활동입니다.",
        url: 'http://s.senaidl.kr/XsDjF',
        qr: 'm-2-1.png'
      },
      27: {
        feedback:
          '기계학습 모델을 만들기 위해서는 어떤 데이터가 결과에 중요한 영향을 미치는지 파악하는 것이 중요해요. 직접 간단한 기계학습 모델을 만들어 보면, 데이터를 통해 학습하고 예측하는 기계학습의 원리를 이해할 수 있어요.',
        study:
          "인공지능이 데이터를 수집하고 전처리, 라벨링하여 예측에 이르는 학습의 전 과정을 AI 스피커 사례로 생생하게 살펴봅니다. 수많은 정보 속에서 AI가 스스로 규칙을 찾아내고 판단하는 원리를 이해하며, 인공지능에게도 인간처럼 체계적인 배움의 단계가 필요함을 깨닫습니다.",
        url: 'http://s.senaidl.kr/kvdgN',
        qr: 'm-4-4.png'
      },
      28: {
        feedback:
          '생성형 인공지능은 주어진 정보를 바탕으로 새로운 콘텐츠(문자, 그림, 음악, 영상 등)를 만들어내는 인공지능이에요. 예를 들어, 글 생성 인공지능은 입력된 질문을 기반으로 새로운 글을 생성하고, 그림 생성 인공지능은 사용자의 설명을 바탕으로 이미지를 그릴 수 있어요. 이런 기술을 이해하면 창의적인 작업에도 인공지능을 활용할 수 있어요.',
        study:
          "인공지능이 제공하는 정보 중에는 사실과 다른 내용이 섞여 있을 수 있음을 이해합니다. 퀴즈와 사례를 통해 AI 답변을 무조건 믿기보다 비판적으로 검토하는 태도를 기르며, 정보에 대한 최종 책임은 사용자에게 있음을 배우고 실천합니다.",
        url: 'http://s.senaidl.kr/cN4WH',
        qr: 'm-5-2.png'
      },
      30: {
        feedback:
          '인공지능의 개념과 원리를 잘 이해하고 있으며, 다양한 사례를 통해 인공지능이 어떻게 활용되는지 폭넓게 학습하였습니다. 앞으로도 인공지능의 발전과 활용 방안에 관심을 가지고 지속적으로 탐구해 보시기 바랍니다.',
        study:
          '<생성형 AI에게 던지는 올바른 질문법> 웹 앱으로 좋은 질문이 정교한 답변을 만드는 원리를 배웁니다. 상황별 최적의 프롬프트를 고르는 시뮬레이션으로 인공지능과 소통하는 기술을 익히고 윤리 수칙도 학습합니다. 막연한 질문을 구체적으로 바꾸며 인공지능을 주도하는 \'프롬프트 마스터\'로 성장하는 활동입니다.',
        url: 'http://s.senaidl.kr/i0CVL',
        qr: 'm-a-2.png'
      }
    },
    'b': {
      12: {
        feedback:
          '인공지능 도구는 목적에 맞게 사용하는 것이 중요해요. 학습 상황에 필요한 인공지능 도구와 기능을 적절히 선택해 활용하고, 인공지능이 학습에 어떻게 도움이 되었는지 돌아보며 적절한 사용 방법을 스스로 정리해 보기를 바랍니다.',
        study:
          '의료, 교육, 창작 등 사회 곳곳에서 활약하는 인공지능 사례를 통해 AI의 무한한 잠재력을 탐색합니다. 인공지능은 단순한 기술을 넘어 우리의 상상력을 현실로 바꾸어 주는 강력한 조력자가 됩니다. AI와 협력해 문제를 해결하며 새로운 가치를 만드는 경험을 통해, 인공지능과 함께 만들어갈 우리 미래의 다양한 가능성을 상상해 보는 활동입니다.',
        url: 'http://s.senaidl.kr/XtpUO',
        qr: 'm-2-3.png'
      },
      13: {
        feedback:
          '생성형 인공지능을 활용하여 결과물을 만들었을 때 의도한 대로 결과가 나오지 않을 수 있어요. 그래서 인공지능의 결과를 그대로 받아들이기보다, 원하는 내용과 맞는지 비판적으로 살펴보고 개선하는 과정이 중요해요. 프롬프트에 따라 결과물이 어떻게 달라지는지 살펴보고, 원하는 콘텐츠를 직접 창작해보세요.',
        study:
          "생성형 AI로 글과 그림을 만드는 사례를 살펴보며, 고품질 콘텐츠를 순식간에 만드는 장점과 저작권 및 정보 오류라는 한계를 분석합니다. AI의 특성을 이해하면 상상력을 현실로 바꾸는 도구로 멋지게 활용할 수 있습니다. 기술을 주도적으로 다루며 창작의 지평을 넓히는 역량을 기르는 활동입니다.",
        url: 'http://s.senaidl.kr/OFVXh',
        qr: 'm-5-5-2.png'
      },
      14: {
        feedback:
          '실생활 문제를 인공지능으로 해결하려면 상황과 목적에 맞는 AI·디지털 도구를 적절히 선택하는 것이 중요해요. 또 인공지능이 제시한 결과를 그대로 믿기보다 다른 자료와 비교하고 근거를 확인해 검토해야 해요. 여러 정보를 종합해 최종 결정을 내리면 더 안전하고 정확하게 문제를 해결할 수 있어요.',
        study:
          "버스 도착 예측 등 우리 생활 곳곳에 스며든 인공지능의 활약을 생생하게 살펴봅니다. 방대한 데이터를 분석해 기다림을 줄여주고 복잡한 소통을 돕는 AI가 우리의 삶을 얼마나 더 편리하고 효율적으로 변화시키는지 이해할 수 있습니다. 더불어 미래 사회에서의 역할을 생각해볼 수 있습니다.",
        url: 'http://s.senaidl.kr/6lVfj',
        qr: 'm-2-4.png'
      },
      19: {
        feedback:
          '인공지능은 그림을 그리거나 음악을 만드는 등 다양한 창작 활동에 활용될 수 있어요. 특히 그리고 싶은 대상, 스타일, 분위기를 구체적으로 설명하여 인공지능에 전달하면 원하는 결과에 더 가까운 작품을 만들 수 있어요.',
        study:
          "생성형 인공지능으로 글과 그림을 만드는 실제 사례를 살펴봅니다. 아이디어를 멋지게 시각화하는 인공지능의 장점과 저작권 및 창의성 논란 같은 한계를 꼼꼼히 비교해 봅니다. 인공지능의 특징을 이해하면 상상력을 현실로 만드는 도구로 멋지게 활용할 수 있습니다.",
        url: 'http://s.senaidl.kr/OFVXh',
        qr: 'm-5-5-1.png'
      },
      22: {
        feedback:
          '번역이 필요할 때는 번역 AI, 길을 찾을 때는 내비게이션 AI처럼, 상황에 맞는 인공지능 도구를 활용하면 문제를 더 쉽게 해결할 수 있어요. 어떤 인공지능이 어떤 기능을 하는지 이해하면, 실생활에서 더욱 효과적으로 사용할 수 있어요.',
        study:
          "이 카드뉴스를 통해 교통안전, 의료보건, 교육, 농업식품 등 우리 사회의 핵심 분야에서 활약하는 인공지능과 데이터 기술의 실제 사례를 살펴봅니다. 복잡한 사회 문제를 해결하고 안전을 지키며, 우리의 삶을 더욱 풍요롭고 편리하게 변화시키는 AI의 역할을 깊이 있게 이해할 수 있습니다.",
        url: 'http://s.senaidl.kr/IWcmZ',
        qr: 'm-4-5.png'
      },
      29: {
        feedback:
          '인공지능이 생활 속에서 어떻게 사용되는지 깊이 이해하고 있으며, 이를 문제 해결에 적용하는 능력이 뛰어납니다. 앞으로는 다양한 인공지능 도구를 직접 활용해 보고, 이를 실생활과 학습에 적극적으로 적용해 보시길 바랍니다.',
        study:
          '일상 속 AI 활용 사례를 살펴보며 책임 있는 사용과 그렇지 못한 사용을 구분해 봅니다. 검토자가 되어 AI 사용 결과를 판단하고, 그 선택이 수익과 신뢰라는 지표에 어떤 영향을 주는지 확인합니다. 게임을 통해 AI 윤리의 중요성을 체감하며, 기술을 올바르고 책임감 있게 사용하는 판단력을 기르는 활동입니다.',
        url: 'http://s.senaidl.kr/KccSP',
        qr: 'm-a-1.png'
      }
    },
    'c': {
      4: {
        feedback:
          '인공지능 기술의 발전으로 우리의 일상은 더욱 편리하고 안전해지고 있어요. 자율주행차나 스마트 기기는 사람의 이동과 생활을 돕고, 사고나 위험한 상황을 줄여줘요. 생활 속 인공지능 사례에 관심을 갖고 살펴보면, 인공지능 기술이 우리 일상생활을 어떻게 변화시키고 있는지 더 잘 이해할 수 있어요.',
        study:
          "AI 기술이 우리 삶에 가져온 변화를 탐색하며, 기술의 긍정적 영향과 부정적 위험을 담은 만화를 통해 AI의 양면성을 생생하게 학습합니다. 제시된 핵심 단어를 활용해 내용을 직접 정리하며 비판적 사고력을 키우고, AI와 공존할 미래 사회에서 필요한 올바른 가치관과 태도를 정립할 수 있도록 구성된 활동입니다.",
        url: 'http://s.senaidl.kr/PHILp',
        qr: 'm-1-3.png'
      },
      5: {
        feedback:
          '인공지능을 사용할 때는 정해진 규칙을 지키고, 인공지능과 어떻게 협력할지 고민하는 것이 중요해요. 특히 AI·디지털 윤리를 이해하고, 인공지능을 신중하고 책임감 있게 활용하는 자세가 필요해요. 인공지능의 편향, 공정성, 신뢰성과 같은 특성을 이해하면 인공지능 윤리 원칙을 더 깊이 이해하는 데 도움이 됩니다.',
        study:
          "인터랙티브 앱으로 AI 사용 습관을 재미있게 진단하고, 3가지 맞춤형 활동을 수행합니다. 일상 속 활용 사례를 통해 기술의 편리함을 누리는 동시에, 부작용을 방지하고 책임감 있게 사용하는 구체적인 방법을 학습합니다. 기술에 휘둘리지 않고 주체적으로 AI와 공존하는 법을 익히는 실천적인 참여형 교육 자료입니다.",
        url: 'http://s.senaidl.kr/5btx4',
        qr: 'm-1-4.png'
      },
      9: {
        feedback:
          '인공지능을 사용할 때에는 자신의 정보뿐만 아니라 타인의 개인정보와 프라이버시도 존중해야 해요. 인공지능 서비스를 이용할 때에는 어떤 정보가 수집·활용되는지 꼼꼼히 확인하고, 필요한 정보만 신중하게 입력해야 해요. 이러한 주의는 인공지능을 안전하고 책임 있게 활용하는 출발점이 됩니다.',
        study:
          '체크리스트로 자신의 AI 사용 습관을 객관적으로 점검하고, 영상 시청을 통해 책임감 있는 활용법을 익힙니다. 학습지 문제를 풀며 배운 내용을 복습한 뒤, 올바른 AI 사용을 위한 다짐을 글로 남깁니다. 기술을 지혜롭고 안전하게 활용하는 성숙한 디지털 시민으로 성장하도록 돕는 실천 중심의 학습 활동입니다.',
        url: 'http://s.senaidl.kr/oUzH4',
        qr: 'm-2-5.png'
      },
      11: {
        feedback:
          '인공지능이 생성한 결과물은 항상 정확하지 않을 수 있어요. 그래서 인공지능의 결과를 그대로 사용하기보다, 편향되거나 부적절한 부분이 있는지 비판적으로 살펴보고 책임 있게 판단하는 태도가 중요해요.',
        study:
          'AI 답변의 정확성을 비판적으로 검토하며, 상황별로 결과물을 어떻게 수용할지 논의합니다. AI 답변이 완벽한 정답이 아님을 인지하고 출처 확인, 개인정보 보호, 결과에 대한 책임의 중요성을 내면화합니다. 기술을 맹신하기보다 스스로 판단하고 책임지는 똑똑한 AI 활용 능력을 기르는 활동입니다.',
        url: 'http://s.senaidl.kr/pd4G1',
        qr: 'm-5-6.png'
      },
      20: {
        feedback:
          '인공지능의 결과가 항상 정답은 아니에요. 그래서 한번 만들어진 모델은 완성형이 아니라 지속적인 개선이 필요합니다. 사용자의 피드백은 시스템의 정확도와 개인화 수준을 높이는 데 필수적이에요. 실제 인공지능 모델은 사용데이터와 피드백을 통해 최적화됩니다.',
        study:
          '독후감 쓰기, 식물 조사 등 학습 상황을 담은 에피소드로 AI·디지털 도구 활용 시 겪을 수 있는 문제점을 생생하게 살펴봅니다. 편리함 뒤에 숨겨진 정보 오류나 의존의 위험성을 스스로 발견하며 비판적 사고의 필요성을 체감합니다. 디지털 세상의 정보를 검증하고 확인하는 올바른 태도를 기르는 활동입니다.',
        url: 'http://s.senaidl.kr/Gjx66',
        qr: 'm-4-6.png'
      },
      23: {
        feedback:
          '우리가 사용하는 인공지능이 특정 집단에 대해서만 편향된 결과를 내놓는다면, 그것은 인공지능이 학습한 데이터 자체가 한쪽으로 치우쳐 있었기 때문이에요. 인공지능의 답변을 무조건 신뢰하기보다, 그 속에 숨겨진 데이터의 불균형이나 고정관념이 없는지 비판적으로 검토하는 습관이 중요해요.',
        study:
          '데이터의 수집 단계부터 최종 배포에 이르기까지, 인공지능이 학습 과정에서 가질 수 있는 편향의 원인과 영향을 심도 있게 살펴봅니다. 특정 집단에 대한 고정관념을 강화하거나 사회적 공정성을 해치는 편향의 위험성을 인지하고, 이를 해결하기 위한 데이터 조정 등의 완화 방안을 학습합니다.',
        url: 'http://s.senaidl.kr/4PGfl',
        qr: 'm-3-6.png'
      },
      24: {
        feedback:
          '인공지능은 학습 보조 도구나 창작 파트너로서 우리에게 큰 이로움을 주지만, 동시에 딥페이크나 편향된 정보 생성 같은 사회적 문제를 일으킬 수도 있어요. 기술이 일상에 깊숙이 들어올수록 그 편리함에만 의존하기보다, 발생할 수 있는 부작용을 미리 예측하고 대비하는 비판적인 시각을 길러야 해요.',
        study:
          "'인공지능의 두 얼굴'은 AI 기술이 우리 삶에 가져온 변화를 다각도로 탐색하는 활동입니다. 인공지능의 좋은 영향, 나쁜 영향을 담은 만화를 보고, 제시된 단어를 활용해 정리합니다. 이를 통해 인공지능의 양면성에 대해 알아볼 수 있습니다.",
        url: 'http://s.senaidl.kr/PHILp',
        qr: 'm-3-4.png'
      },
      25: {
        feedback:
          '인공지능의 성능 향상과 개인정보 보호는 정답이 없는 가치 충돌의 문제예요. 기술의 효율성만 쫓기보다 우리 사회가 더 중요하게 지켜야 할 가치가 무엇인지 고민하며 균형을 잡는 태도가 필요해요.',
        study:
          '인공지능 윤리적 딜레마의 개념을 학습하는 활동입니다. 인공지능 자율 주행 자동차와 관련된 의사 결정 과정을 직접 경험함으로써 인공지능으로 인해 윤리적 딜레마가 발생할 수 있다는 것을 이해하는 것에 목표가 있습니다.',
        url: 'http://s.senaidl.kr/cZTYA',
        qr: 'm-3-5.png'
      },
      31: {
        feedback:
          '인공지능을 사용할 때 윤리적인 관점을 고려하며, 개인정보 보호와 공정한 AI 활용의 중요성을 잘 이해하고 있습니다. 앞으로도 인공지능을 안전하고 책임감 있게 사용하며, 이를 통해 더욱 발전된 사고력을 기를 수 있도록 노력해 보시기 바랍니다.',
        study:
          "SNS 게시물 속 개인정보를 직접 찾아보며 정보 보호의 중요성을 체감합니다. 나뿐만 아니라 타인의 정보까지 소중히 다루는 방법을 탐색하고, 퀴즈를 통해 일상 속 실천 방안을 학습합니다. 무심코 올린 사진이나 글의 위험성을 인지하고, 안전한 디지털 생활을 위해 스스로 정보를 지키는 책임감 있는 태도를 기르는 활동입니다.",
        url: 'http://s.senaidl.kr/1euWG',
        qr: 'm-a-3.png'
      }
    },
    'd': {
      6: {
        feedback:
          '인간과 인공지능 모두 문제를 해결하고 정보를 분석할 수 있지만, 학습 방식과 사고 과정이 달라요. 인간은 감정과 창의력을 바탕으로 배우지만, 인공지능은 데이터를 기반으로 학습하고 특정한 패턴을 찾아내요. 이런 차이를 이해하면, 인공지능을 보조 도구로 활용하는 방법을 더 효과적으로 찾을 수 있어요.',
        study:
          "감정과 장르 설정에 따른 AI 창작물을 직접 비교하며 체험합니다. 학생들은 아트 디렉터가 되어 시, 그림, 음악 등 다양한 창작 과정을 주도적으로 경험합니다. 이를 통해 인간의 섬세한 의도와 감정이 결과물의 품질을 결정하는 핵심 요소임을 이해하고, 기술과 예술의 협업 가능성을 탐구하는 창의적 활동입니다.",
        url: 'http://s.senaidl.kr/4H631',
        qr: 'm-5-1.png'
      },
      10: {
        feedback:
          '인간과 인공지능 모두 문제를 해결하고 정보를 분석할 수 있지만, 학습 방식과 사고 과정이 달라요. 인간은 감정과 창의력을 바탕으로 배우지만, 인공지능은 데이터를 기반으로 학습하고 특정한 패턴을 찾아내요. 이런 차이를 이해하면, 인공지능을 보조 도구로 활용하는 방법을 더 효과적으로 찾을 수 있어요.',
        study:
          "인간과 인공지능이 새로운 결과물을 만드는 과정을 비교하며 각자의 강점을 찾아봅니다. 사람의 직관과 인공지능의 데이터 처리 능력이 만났을 때의 변화를 탐색하고, 서로 잘하는 영역을 구분해 봅니다. 인공지능을 단순한 도구가 아닌 파트너로 삼아 더 큰 가치를 만드는 현명한 협업 방식을 함께 고민하는 활동입니다.",
        url: 'http://s.senaidl.kr/zhV4Y',
        qr: 'm-3-2.png'
      },
      15: {
        feedback:
          '인공지능은 카메라나 거리 측정 센서와 같은 다양한 센서를 활용해 주변 환경을 인식해요. 이러한 기능을 활용하면 교통 안전이나 에너지 절약과 같은 지속 가능한 사회의 문제를 해결하는 방법을 구상할 수 있어요. 직접 프로그래밍을 통해 센서를 활용하면, 인공지능의 원리를 더 쉽게 이해할 수 있어요.',
        study:
          '인간과 인공지능이 힘을 합쳐 더 큰 가치를 만드는 협업 사례를 탐구합니다. 인공지능의 빠른 효율성과 인간의 윤리적 판단이 만날 때 생기는 시너지를 이해하고, 기술과 현명하게 공존하는 방법을 배웁니다. 기술에 휘둘리지 않고 책임감 있게 인공지능을 주도하는 성숙한 사용자의 태도를 다지는 활동입니다.',
        url: 'http://s.senaidl.kr/nuk14',
        qr: 'm-1-2.png'
      },
      32: {
        feedback:
          '인공지능은 우리 일을 도와주는 유용한 도구로, 잘 활용하면 삶이 훨씬 편리해집니다. 하지만 사용하기 전에 우리가 직접 해야 할 일과 인공지능에게 맡겨도 될 일을 잘 구분해야 합니다. 인공지능과 어떤 사이가 되는 것이 좋을지 한번 곰곰이 생각해보세요.',
        study:
          'AI의 편향성과 오류 사례를 통해 인간 중심 인공지능의 필요성을 배웁니다. 가상 시나리오로 공정성과 투명성을 진단하고, 데이터 수정과 인간의 개입을 거쳐 AI를 직접 다시 설계해 봅니다. 기술의 한계를 비판적으로 바라보고, 모두가 신뢰할 수 있는 인공지능을 만드는 책임감 있는 태도를 기르는 활동입니다.',
        url: 'http://s.senaidl.kr/rVS0t',
        qr: 'm-a-4.png'
      }
    }
  }
};



// 카테고리 매핑
const categoryMapping = {
    'a': 'AI·디지털 기술<br>(보충 학습)',
    'b': 'AI·디지털 활용<br>(보충 학습)', 
    'c': 'AI·디지털 윤리<br>(보충 학습)',
    'd': '인간 중심 AI<br>(보충 학습)'
};

// studentData를 기반으로 보충학습 데이터 생성
const aiSuggestionData = computed(() => {
    console.log('=== Page4 - aiSuggestionData computed 시작 ===');
    
    if (!props.studentData) {
        console.log('❌ Page4 - studentData가 없음');
        return { student: [] };
    }

    const schoolLevel = (props.studentData.schul_type || 'E').toLowerCase();
    console.log('Page4 - schoolLevel:', schoolLevel);
    
    const suggestions = [];

    // improvement1_type ~ improvement4_type까지 처리
    for (let i = 1; i <= 4; i++) {
        const typeKey = `improvement${i}_type`;
        const materialsKey = `improvement${i}_materials`;
        
        const improvementType = props.studentData[typeKey];
        const materials = props.studentData[materialsKey];
        
        console.log(`Page4 - improvement${i}:`, { type: improvementType, materials });
        
        if (improvementType && materials) {
            let data = null;
            
            // 먼저 정확한 매칭을 시도
            if (suggestionData[schoolLevel] && 
                suggestionData[schoolLevel][improvementType] && 
                suggestionData[schoolLevel][improvementType][materials]) {
                data = suggestionData[schoolLevel][improvementType][materials];
                console.log(`✅ Page4 - Found exact match for improvement${i}`);
            }
            // 정확한 매칭이 없으면 해당 타입의 default 사용
            else if (suggestionData[schoolLevel] && 
                     suggestionData[schoolLevel][improvementType] && 
                     suggestionData[schoolLevel][improvementType]['default']) {
                data = suggestionData[schoolLevel][improvementType]['default'];
                console.log(`⚠️ Page4 - Using default for improvement${i}: type=${improvementType}, materials=${materials}`);
            }
            
            if (data) {
                suggestions.push({
                    category: categoryMapping[improvementType],
                    desc: data.feedback,
                    resource: {
                        text: data.study,
                        url: data.url,
                        qr: `https://kr.object.gov-ncloudstorage.com/cbt-object/result/literacy/qr/${data.qr}`
                    }
                });
                console.log(`✅ Page4 - Added suggestion ${i}/${suggestions.length}`);
            } else {
                console.log(`❌ Page4 - No data found for improvement${i}:`, { improvementType, materials });
            }
        }
    }

    console.log('=== Page4 - Final result ===');
    console.log('Total suggestions:', suggestions.length);
    console.log('Suggestions:', suggestions);
    
    return {
        student: suggestions
    };
});
</script>

<template>
  <div class="report-inner">   
    <div class="card-wrap">
      <AiSuggestionList :userRole="userRole" :data="aiSuggestionData" />       
    </div>        
  </div>
</template>
